import { Span, Text } from "@clipboard-health/ui-components";
import { CardContent, Link } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";
import { useZendeskArticle } from "@src/appV2/Zendesk/useZendeskArticle";

import { WorkplaceReferralAction, WorkplaceReferralComponent } from "../types";
import { WorkplaceReferralCard } from "./WorkplaceReferralCard/WorkplaceReferralCard";

interface ReferralPolicyProps {
  referralCode?: string;
}

export function ReferralPolicy(props: ReferralPolicyProps) {
  const { referralCode } = props;
  const { referralPolicySupportLink } = useSupportLinks();
  const { openArticle } = useZendeskArticle();

  return (
    <WorkplaceReferralCard>
      <CardContent>
        <Text textAlign="center">
          <Span sx={{ verticalAlign: "middle" }}>Read our Affiliate Program Policy</Span>{" "}
          <Link
            component="button"
            onClick={async () => {
              logEvent(APP_V2_USER_EVENTS.WORKPLACE_REFERRAL, {
                action: WorkplaceReferralAction.REFERRAL_POLICY_CLICKED,
                component: WorkplaceReferralComponent.REFERRAL_POLICY_SECTION,
                referralCode,
              });
              await openArticle(referralPolicySupportLink);
            }}
          >
            here.
          </Link>
        </Text>
      </CardContent>
    </WorkplaceReferralCard>
  );
}
